import React from 'react';
import PropTypes from 'prop-types';
import { educationLevels } from '../../copy/educationLevels';

const GraduateIcon = ({ color, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      fill={color}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      role="img"
    >
      <title>{educationLevels().level7.label}</title>
      <path
        d="M935.5,137.6c-19.8-18.5-29-38.3-27.7-58c0-33,27.7-56.7,27.7-56.7c4-4,5.3-9.2,4-14.5c-1.3-5.3-6.6-7.9-11.9-7.9H183.5
		C114.9,0.4,60.9,36,60.9,80.9v814c0,58,55.4,105.5,122.7,105.5h742.7c7.9,0,13.2-5.3,13.2-13.2V150.8c0-1.3,0-1.3,0-2.6
		C939.5,144.2,938.2,140.2,935.5,137.6z M183.5,25.5h715c-7.9,13.2-17.2,31.7-17.2,52.8c0,18.5,5.3,36.9,17.2,54.1h-715
		c-52.8,0-96.3-25.1-96.3-54.1S130.8,25.5,183.5,25.5z M422.3,402.8c0,0-1.3,0-1.3-1.3c-1.3,0-1.3-1.3-2.6-1.3c-1.3,0-1.3,0-2.6,0
		c-1.3,0-1.3,0-2.6,0c-1.3,0-1.3,0-2.6,1.3c0,0-1.3,0-1.3,1.3l-66,40.9V160h145.1v285L422.3,402.8z M87.2,894.9V129.7
		c18.5,14.5,44.9,25.1,75.2,29v812.7C120.2,963.5,87.2,931.8,87.2,894.9z M188.8,972.7V160h126.6v308.7c0,5.3,2.6,9.2,6.6,11.9
		c2.6,1.3,4,1.3,6.6,1.3s5.3-1.3,6.6-2.6l79.2-48.8l79.2,48.8c2.6,1.3,4,2.6,6.6,2.6c2.6,0,4,0,6.6-1.3c4-2.6,6.6-6.6,6.6-11.9V160
		h398.4v814h-723V972.7z"
      />
    </svg>
  );
};

export default GraduateIcon;

GraduateIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};
